import * as Yup from 'yup';
import { notAllowedWord, reservedValues } from './reservedKeywords';

const types = {
  FIELDS: 'FIELDS',
  CONSTRUCTOR: 'CONSTRUCTOR',
  DERIVED_FIELD: 'DERIVED_FIELD',
  CONSTANT: 'CONSTANT',
  FILTER: 'FILTER',
  CONSTRAINT: 'CONSTRAINT',
  COPYTO: 'COPYTO',
  VALIDATION: 'VALIDATION',
  WORKFLOW: 'WORKFLOW',
  INDEXING: 'INDEXING',
  PERMISSION_LEVEL_SECURITY: 'PERMISSION_LEVEL_SECURITY',
  ROW_LEVEL_SECURITY: 'ROW_LEVEL_SECURITY',
  TYPESENSE_MAPPING: 'TYPESENSE_MAPPING',
  COLLECTION_MAPPING: 'COLLECTION_MAPPING',
  FIELD_OBJECT_MAPPING: 'FIELD_OBJECT_MAPPING',
  GOOGLE_CALENDAR_MAPPING: 'GOOGLE_CALENDAR_MAPPING',
  DERIVED_FIELD_MAPPING: 'DERIVED_FIELD_MAPPING',
};

export const fieldSchema = () => {
  let schema = {
    fieldTitle: { en: '' },
    type: 'text',
    placeholder: { en: '' },
    validation: {
      min: null,
      max: null,
      regex: '',
      allowedFileTypes: [],
      noAllowedFiles: 1,
    },
    required: false,
    unique: false,
    isMultiSelect: false,
    refCollection: {
      collectionName: '',
      collectionField: '',
      parentCollectionField: '',
      //this value is not actual value please see before form submission for more details
      //actual value is dropdown
      displayType: 'dropdown',
      isShowAsText: false,
      isShowAsRadioOrCheckBox: false,
      isFileType: false,
    },
    extraFieldSetting: {
      dateDisplayType: 'date',
      textareaDisplayType: 'text-area',
      algorithm: '',
      prepend: '',
      append: '',
      minLength: 1,
      defaultValue: '',
    },
    staticOptions: [],
  };
  return schema;
};
export const fieldSchemaValidation = () => {
  let validationSchema = {
    fieldTitle: Yup.object().shape({
      en: Yup.string()
        .required("Field name can't be blank")
        .max(100, 'Field name can not be more than 100 characters.')
        .matches(/^[A-Za-z0-9\s_]+$/, 'Name should not contain special characters')
        .test('reserved', 'This is reserved word please use another', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !reservedValues.includes(lowercaseValue);
        })
        .test('not-allowed', 'This type of word not allowed.', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !notAllowedWord.includes(lowercaseValue);
        }),
    }),
  };
  return Yup.object().shape(validationSchema);
};

export const fileTypes = [
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
  'txt',
  'rtf',
  'html',
  'zip',
  'mp3',
  'wma',
  'mpg',
  'flv',
  'avi',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'pptx',
  'ppt',
  'heic',
  'webp',
];
export const projectOnBoardAllowedField = [
  'text',
  'large_text',
  'number',
  'date',
  'password',
  'color',
  'url',
  'tel',
  'email',
  'boolean',
];
export const validationForPdfToText = () => {
  let validationSchema = {
    collection: Yup.string().required("Collection Name can't be blank"),
    fieldForPdf: Yup.string().required("Field Name can't be blank"),
    fieldForText: Yup.string().required("Field Name can't be blank"),
  };
  return Yup.object().shape(validationSchema);
};
export const validationForAmazonTextract = () => {
  let validationSchema = {
    collection: Yup.string().required("Collection Name can't be blank"),
    fieldForDocument: Yup.string().required("Field Name can't be blank"),
    fieldForText: Yup.string().required("Field Name can't be blank"),
  };
  return Yup.object().shape(validationSchema);
};

export const getValidationSchemaForTextAnonymization = (showCustomTermsField) => {
  let validationSchema = {
    collection: Yup.string().required("Collection Name can't be blank"),
    fieldForSourceText: Yup.string().required("Field Name can't be blank"),
    fieldForAnonymizedText: Yup.string().required("Field Name can't be blank"),
  };

  if (showCustomTermsField) {
    validationSchema.fieldForCustomTerms = Yup.string().required("Field Name can't be blank");
  }

  return Yup.object().shape(validationSchema);
};

export const uploadTypes = {
  CSV: 'CSV',
  REST_API: 'REST_API',
  JSON: 'JSON',
  DB_DUMP: 'DB_DUMP',
};

export const validationForFunctionExecution = () => {
  let validationSchema = {
    FunctionName: Yup.string().required("Function Name can't be blank"),
  };
  return Yup.object().shape(validationSchema);
};

export const validationForFloatingModal = () => {
  let validationSchema = {
    floatingModalId: Yup.string().required("Floating Modal Name can't be blank"),
  };
  return Yup.object().shape(validationSchema);
};

export default types;
